const WebView = () => import('@/pages/system/web-view')

const CreateWebView = () => import('@/pages/system/web-view/create')

const EditWebView = () => import('@/pages/system/web-view/edit')

export default {
  path: 'web-view',
  meta: {
    label: 'webView',
    auth: 'webView'
  },
  component: {
    name: 'WebView',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemWebViewReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: WebView
    },
    {
      name: 'SystemCreateWebView',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateWebView
    },
    {
      name: 'SystemEditWebView',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditWebView
    }
  ]
}
